<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Button, Table, type TableColumnType } from 'ant-design-vue'
import { debouncedWatch } from '@vueuse/core'
import { Status } from '-/Common/Status'
import { useFetch } from '@/hooks/useFetch'
import { API_FUND_AUDIT_USER_FILE_PREVIEW } from '@/api/fundAudit'
import { useRouter } from 'vue-router'
import { useActionKey } from '@/plugins/actionKey'
const [name] = createNamespace('FundAuditUserFilePreview')
export default defineComponent({
  name,
  props: {
    pId: {
      type: String as PropType<string>
    },
    id: {
      type: String as PropType<string>
    },
    dataSource: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    useApi: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup(props) {
    const { loading, result, fetchData } = useFetch({
      getFn: API_FUND_AUDIT_USER_FILE_PREVIEW
    })
    if (props.useApi) {
      debouncedWatch(
        [() => props.id, () => props.pId],
        ([id, pId]) => {
          if (id && pId) {
            fetchData({ fileId: id, projectId: pId })
          }
        },
        { immediate: true, debounce: 100 }
      )
    }
    const $AK = useActionKey()
    const router = useRouter()
    const dataSource = computed(() => (props.useApi ? result.value : props.dataSource))
    const columns: TableColumnType[] = [
      { title: '序号', dataIndex: '序号', width: 80 },
      { title: '姓名', dataIndex: '名字', width: 100 },
      { title: '身份证号', dataIndex: '身份证号', width: 200 },
      { title: '拆迁补偿', dataIndex: '拆迁补偿', width: 150 },
      {
        title: '匹配状态',
        dataIndex: '匹配状态',
        width: 100,
        customRender({ record }) {
          return <Status type={record['征拆户id'] ? 'success' : 'error'}>{record['征拆户id'] ? '匹配成功' : '匹配失败'}</Status>
        }
      },
      {
        title: '操作',
        dataIndex: '征拆户详情',
        fixed: 'right',
        width: 100,
        customRender({ record }) {
          const params = { id: record['征拆户id'], pId: props.useApi ? props.pId : record['项目id'] }
          if (params.id && params.pId) {
            const { href } = router.resolve({
              name: $AK.JT_ZCH.DETAIL,
              params: { id: record['征拆户id'], pId: props.useApi ? props.pId : record['项目id'] }
            })
            return (
              <Button type='link' size='small' href={href} disabled={!record['征拆户id']} target='_blank'>
                征拆户详情
              </Button>
            )
          }
          return '-'
        }
      }
    ]
    return () => <Table columns={columns} loading={loading.value} size='small' dataSource={dataSource.value} scroll={{ y: 800 }}></Table>
  }
})
</script>
